import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { StudentModalComponent } from 'src/app/modals/student-modal/student-modal.component';
import { StudentService } from 'src/app/providers/student/student.service';
import { DeleteConfirmDialogComponent } from 'src/app/shared/delete-confirm-dialog/delete-confirm-dialog.component';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.scss']
})
export class StudentComponent implements OnInit {
  public studentData;

  constructor(public dialog: MatDialog, 
    public studentService: StudentService) 
  {
    this.getStudentData();
   }

   openDialogStudent(): void {
    const dialogRef = this.dialog.open(StudentModalComponent, {
      width: '350px',
      data: {
        title: 'Create new class'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getStudentData();
    });
  }

  getStudentData() {
    this.studentService.viewStudent()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.studentData = data;
        });    
  }

  // editing student
  editStudent(studentObj) {
    const dialogRef = this.dialog.open(StudentModalComponent, {
      width: '350px',
      data: {
        id: studentObj.sysRef,
        firstname: studentObj.firstName,
        lastname: studentObj.lastName,
        studentid: studentObj.studentId,
        phone: studentObj.phone,
        email: studentObj.email,
        title: 'Edit student ' + studentObj.firstName
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getStudentData();
    });
  }

  // deleting a student
  deleteStudent(studentObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'student',
        id: studentObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove student: ' + studentObj.firstName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getStudentData();
    });
  }

  ngOnInit(): void {
  }

}
